/**
 * Language fallback utility
 * If one language field is empty, use the other as fallback
 */

interface BilingualFields {
  nameAr?: string | null
  nameFr?: string | null
  descriptionAr?: string | null
  descriptionFr?: string | null
  addressAr?: string | null
  addressFr?: string | null
}

/**
 * Apply fallback logic to bilingual fields
 * If one language is missing, use the other language
 */
export function applyLanguageFallback<T extends BilingualFields>(fields: T): T {
  const result = { ...fields }

  // Name fallback
  if ('nameAr' in result && 'nameFr' in result) {
    if (!result.nameAr && result.nameFr) {
      result.nameAr = result.nameFr
    } else if (!result.nameFr && result.nameAr) {
      result.nameFr = result.nameAr
    }
  }

  // Description fallback
  if ('descriptionAr' in result && 'descriptionFr' in result) {
    if (!result.descriptionAr && result.descriptionFr) {
      result.descriptionAr = result.descriptionFr
    } else if (!result.descriptionFr && result.descriptionAr) {
      result.descriptionFr = result.descriptionAr
    }
  }

  // Address fallback
  if ('addressAr' in result && 'addressFr' in result) {
    if (!result.addressAr && result.addressFr) {
      result.addressAr = result.addressFr
    } else if (!result.addressFr && result.addressAr) {
      result.addressFr = result.addressAr
    }
  }

  return result
}

/**
 * Get display name with fallback
 */
export function getDisplayName(nameAr: string | null | undefined, nameFr: string | null | undefined, currentLanguage: 'ar' | 'fr'): string {
  if (currentLanguage === 'ar') {
    return nameAr || nameFr || ''
  } else {
    return nameFr || nameAr || ''
  }
}

/**
 * Get display description with fallback
 */
export function getDisplayDescription(descriptionAr: string | null | undefined, descriptionFr: string | null | undefined, currentLanguage: 'ar' | 'fr'): string {
  if (currentLanguage === 'ar') {
    return descriptionAr || descriptionFr || ''
  } else {
    return descriptionFr || descriptionAr || ''
  }
}
